import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditModal from './components/modal.vue';
import { getApplyList as _getApplyList, applyDel } from 'api/approval/config';
export default {
  components: {
    EditModal: EditModal
  },
  data: function data() {
    return {
      applyId: '',
      type: 'add',
      // add or edit
      currentEdit: {},
      tableData: [],
      // 表格数据
      editVisible: false,
      // 编辑组件展示
      load: false,
      // loading
      editTitle: '',
      // 编辑弹窗标题
      form: {
        page: 1,
        page_size: 20,
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.$emit('clear-loading');
    this.getApplyList();
  },
  methods: {
    // 打开编辑组件
    // @parma { String } type value add or edit
    handlerEditrule: function handlerEditrule(type) {
      var _this = this;
      this.type = type;
      this.editVisible = !this.editVisible;
      this.$nextTick(function () {
        _this.editVisible && (_this.$refs.edit.visible = true);
        if (type === 'edit') _this.$refs.edit.applyDeyail();
      });
    },
    // 获取列表数据
    getApplyList: function getApplyList() {
      var _this2 = this;
      this.load = true;
      _getApplyList(this.form).then(function (res) {
        _this2.tableData = res.data.result;
        _this2.form.total = res.data.count;
      }).finally(function () {
        return _this2.load = false;
      });
    },
    // 编辑
    handleClick: function handleClick(row) {
      this.applyId = row.id;
      this.handlerEditrule('edit');
    },
    // 删除
    handlerDel: function handlerDel(id) {
      var _this3 = this;
      this.$confirm(this.$t('1795'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return applyDel({
                id: id
              });
            case 2:
              _this3.getApplyList();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    },
    // 分页
    handleSizeChange: function handleSizeChange(pageSize) {
      this.form.page = 1;
      this.form.page_size = pageSize;
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.form.page = page;
      this.getApplyList();
    }
  }
};